import { useSearchParams } from 'react-router-dom';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { COMMUNITY_AMBASSADOR_FEATURE_FLAG } from '../utils/constants';
import { useState } from 'react';
import { AmbassadorOffboardingForm } from '../components/ambassadors/ambassadorOffboardingForm';
import { AmbassadorOffboardingConfirmation } from '../components/ambassadors/ambassadorOffboardingConfirmation';

export function AmbassadorOffboarding() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div data-testid="ambassador-offboarding-page">
      {!submitted ? (
        <AmbassadorOffboardingForm setSubmitted={setSubmitted} />
      ) : (
        <AmbassadorOffboardingConfirmation />
      )}
    </div>
  );
}

export function AmbassadorOffboardingView() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();

  if (featureIsEnabled(COMMUNITY_AMBASSADOR_FEATURE_FLAG, features, searchParams)) {
    return <AmbassadorOffboarding />;
  }
  return <></>;
}
